import { Box } from "@mui/material";
import { formatDate, formatDateTime } from "../utils/date-time-utility";
import { DEFAULT_FONTSIZE } from "../utils/utils";
import { screenerAnswerText } from "../pages/app/provider/scheduling/appointment/encounter/Assessment/free-text-screening";

interface AssessmentReportTemplateProps {
  data: any;
  screenerType: string;
}

const cellStyle: React.CSSProperties = {
  border: "1px solid #ccc",
  padding: "6px 10px",
  fontSize: DEFAULT_FONTSIZE.fontSize,
  textAlign: "center",
  verticalAlign: "middle",
};

const headerCellStyle: React.CSSProperties = {
  ...cellStyle,
  backgroundColor: "#f5f5f5",
  fontWeight: "bold",
};

const AssessmentReportTemplate = ({
  data,
  screenerType,
}: AssessmentReportTemplateProps) => {
  return (
    <Box
      sx={{
        fontFamily: "Arial, sans-serif",
        padding: "20px",
        color: "#000",
      }}
    >
      {/* Title */}
      <Box
        sx={{
          textAlign: "center",
          mt: 2,
          mb: 2,
          borderBottom: "1px solid #ccc",
          pb: 2,
        }}
      >
        <Box sx={{ fontSize: "20px", fontWeight: "bold" }}>
          Screening Assessment Report
        </Box>
      </Box>

      {/* Patient Info */}
      <Box sx={{ mb: 2, display: "flex", flexDirection: "column", gap: "4px" }}>
        <Box sx={{ fontSize: DEFAULT_FONTSIZE.fontSize }}>
          <strong>Patient:</strong> {data?.patientName ?? "-"}
        </Box>
        <Box sx={{ fontSize: DEFAULT_FONTSIZE.fontSize }}>
          <strong>DOB:</strong> {data?.dob ? formatDate(data.dob) : "-"}
        </Box>
        <Box sx={{ fontSize: DEFAULT_FONTSIZE.fontSize }}>
          <strong>Completed On:</strong>{" "}
          {data?.createdAt ? formatDateTime(data.createdAt) : "-"}
        </Box>
        <Box sx={{ fontSize: DEFAULT_FONTSIZE.fontSize }}>
          <strong>Assessed By:</strong> {data?.assessedBy ?? "-"}
        </Box>
      </Box>

      {/* Table */}
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          pageBreakInside: "avoid",
        }}
      >
        <thead>
          <tr>
            <th style={{ ...headerCellStyle, width: "45%" }}>Question</th>
            <th style={{ ...headerCellStyle, width: "30%" }}>Answer</th>
            <th style={{ ...headerCellStyle, width: "25%" }}>
              Risk Score ({data?.score ?? 0})
            </th>
          </tr>
        </thead>
        <tbody>
          {/* Section row */}
          <tr>
            <td style={{ ...cellStyle, fontWeight: "bold", textAlign: "left" }}>
              <strong>Section:</strong> {screenerType}
            </td>
            <td style={cellStyle} colSpan={2}>
              {data?.score ?? 0} - {data?.severity ?? "-"}
            </td>
          </tr>

          {/* Question rows */}
          {data?.screenerQuestionAnwerResponseSet?.map((item: any) => (
            <tr key={item.uuid}>
              <td style={{ ...cellStyle, textAlign: "left" }}>
                {item.question}
              </td>
              <td style={cellStyle}>{screenerAnswerText(item) || "-"}</td>
              <td style={cellStyle}>{item.individualScore ?? 0}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Box>
  );
};

export default AssessmentReportTemplate;
